import axios from '../../axios'

export default {
  getRailObjects: function () {
    return axios.get('railobjects')
  },
  getRailObjectChildren: function () {
    return axios.get('railobjects/children')
  },
  getNewRailObjects: function (length) {
    return axios.get('railobjects/new/' + length)
  },
  getRailObjectById: function (id) {
    return axios.get('railobjects/' + id).then(response => response.data)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/RailObjectsApi.js